import React from "react";
import axios from "axios";
import { Button } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import LaunchIcon from "@mui/icons-material/Launch";
import ArticleIcon from "@mui/icons-material/Article";
import BASE_URL from "../../config/apiConfig";
import { generateDownload } from '../../util/FormUtils';

const Download = ({ fileId, category }) => {
    // const [fileName, setFileName] = useState("");

    const handleFileDownload = () => {
        axios.get(BASE_URL + `/api/box/download/${fileId}`, { responseType: "blob", withCredentials : true }).then((response) => {
            generateDownload(response);
        }).catch((error) => {
            console.error("Failed to download file:", error);
        });
    };

    const DownloadButton = () => {
        return (
            <Button
                variant="text"
                color="primary"
                startIcon={<GetAppIcon />}
                onClick={handleFileDownload}
            >
                DOWNLOAD
            </Button>
        );
    };

    const BoxViewButton = () => {
        return (
            <Button
                variant="text"
                color="primary"
                startIcon={<LaunchIcon />}
                onClick={() => {
                    window.open(`https://bri.app.box.com/file/${fileId}`);
                }}
                title={`https://bri.app.box.com/file/${fileId}`}
            >
                VIEW IN BOX
            </Button>
        );
    };

    const PullListTemplateButton = () => {
        return (
            <Button
                variant="text"
                color="primary"
                startIcon={<ArticleIcon />}
                onClick={() => {
                    window.open(`https://bri.app.box.com/file/1550576158804`);
                }}
                title={`https://bri.app.box.com/file/1550576158804`}
            >
                PULL LIST TEMPLATE
            </Button>
        );
    };

    return (
        <div
            style={{
                display: "flex",
                gap: "0.6rem",
                alignItems: "center",
                marginTop: "0.4rem",
            }}
        >
            {fileId && fileId !== "" && (
                <>
                    <DownloadButton />
                    <div style={{ width: "1px", height: "20px", backgroundColor: "#949494" }} />
                    <BoxViewButton />
                    {category === "pullListFile" &&
                        <div style={{ width: "1px", height: "20px", backgroundColor: "#949494" }}/>
                    }
                </>
            )}
            {category === "pullListFile" &&
                <PullListTemplateButton />
            }
        </div>
    );
};

export default Download;
